import {memo} from 'react';

import styled from 'styled-components';

import Button from '~/shared/components/Button';
import {flexCenterVertically} from '~/shared/theme/FlexLayout';
import {smallBold} from '~/shared/theme/typography';
import {BackArrow} from '~/shared/components/BackArrow';

const Root = styled.div`
  width: 100%;
  min-height: 56px;
  box-shadow: ${({theme}) => theme.shadows.shadow2};
  ${flexCenterVertically}
  padding: 0 16px;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1;
`;

const Spacer = styled.div`
  flex: 1;
`;

const Title = styled.span`
  flex: 2;
  ${smallBold}
  color: ${({theme}) => theme.colors.charcoal80};
  text-align: center;
`;

const ToggleButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`;

const ToggleButton = styled(Button)`
  width: 24px;
  display: flex;
  height: inherit;
  justify-content: center;
  flex-direction: column;
`;

const MobileStandaloneHeader = ({
  className = '',
  onBackClick,
  title,
}: {
  className?: string;
  title: string;
  onBackClick?: () => void;
}) => {
  return (
    <Root className={className}>
      <Wrapper>
        <ToggleButtonWrapper>
          <ToggleButton onClick={onBackClick}>
            {' '}
            <BackArrow />
            {' '}
          </ToggleButton>
        </ToggleButtonWrapper>
        <Title>{title}</Title>
        <Spacer />
      </Wrapper>
    </Root>
  );
};

export default memo(MobileStandaloneHeader);
